import {
  Backdrop,
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Divider,
  Modal
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import axios from 'src/utils/axios';
import clsx from 'clsx';
import React, { useState } from 'react';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { useTranslation } from 'react-i18next';
import { saveFotograf, base64Reader } from 'src/utils/storage/StrPhoto';
import AlertYasal from '@material-ui/lab/Alert';
import CompensationForm from 'src/views/WorkOrder/CompensationForm';

const Compress = require('compress.js');

const compress = new Compress();
const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

function FilePopup({
  open,
  onClose,
  customer,
  ReceiptNo,
  DosyaTipi,
  DosyaTipiText,
  className,
  CompFiles,
  ...rest
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [label, setLabel] = useState(t('PhotoType0'));
  const [loading, setLoading] = useState(false);
  const [filesCompensation,setFilesCompensation] = useState([]);
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();

  if (!open) {
    return null;
  }

  const handleChangeStatus = ({ meta }, status) => {};

  const getFilesForCompensation = () => {
    axios
      .get(
        `/GetFilesForCompensation/${ReceiptNo || 0}`
      )
      .then(response => {
        if(response.data.length > 0 && response.data != ""){
          setFilesCompensation(response.data);
          CompFiles(response.data);
        }else{
          setFilesCompensation([]); //no data
        }
      })
      .catch(error => {
        setUyariTip('error');
        setUyari(true);
      });
  };

  const handleSubmit = async (files, allFiles) => {

    if (!window.navigator.onLine) {
      // offline
      setLoading(true);
      files.forEach(f => {
        let reader = new FileReader();
        reader.onload = function(base64) {
          saveFotograf(
            ReceiptNo,
            base64.target.result,
            DosyaTipi,
            f.meta.name,
            f.meta.type
          );
        };
        reader.readAsDataURL(f.file);
      });
      allFiles.forEach(f => f.remove());
      setLabel(t('lblOfflineFileControl'));
      setLoading(false);
    } else {
      setLoading(true);
      const total = files.length;
      let success = 0;
      for (let i = 0; i < files.length; i++) {
        const { file } = files[i];
        const { meta } = files[i];
        let base64Result = '';
        if (meta.type.indexOf('image') !== -1) {
          const resizedImage = await compress.compress([file], {
            size: 0.3, // the max size in MB, defaults to 2MB
            quality: 1, // the quality of the image, max is 1,
            maxWidth: 1920, // the max width of the output image, defaults to 1920px
            maxHeight: 1920, // the max height of the output image, defaults to 1920px
            resize: true // defaults to true, set false if you do not want to resize the image width and height
          });
          const img = resizedImage[0];
          base64Result = img.data;
        } else {
          base64Result = await base64Reader(file);
        }
        const data = {
          Title: `${DosyaTipiText === undefined ? '':DosyaTipiText} - ${meta.name}`,
          MIMEType: meta.type,
          WorkOrderId: ReceiptNo,
          FileType: DosyaTipi.toString(),
          FileData: base64Result
        };
        const config = {
          headers: { 'Content-Type': 'application/json' }
        };
        await axios
          .post('/FileImportExport/SiriusFileUpload', data, config)
          // eslint-disable-next-line
          .then(response => {
            success += response.data ? 1 : 0;
            getFilesForCompensation();
           
          })
          .catch(error => {});
      }
      allFiles.forEach(f => f.remove());
      if (total === 0) {
        setLabel(t('PhotoType0'));
      }
      /* else {
        total === success ?
          setLabel(total === 1 ? t('lblBasarili') : t('lblBasarili') )
          :
          setLabel(success + t('lblBasarili') + (total - success) + t('lblBasarili') );
      } */
      setLoading(false);
    }

    onClose();
  };
  
  const Layout = ({
    input,
    previews,
    submitButton,
    dropzoneProps,
    files,
    extra: { maxFiles }
  }) => {
    const drop = (dropzoneProps, input) => {
      return <div {...dropzoneProps}>{input}</div>;
    };
    return (
      <div>
        {previews}
        {files.length < maxFiles && drop(dropzoneProps, input)}
        {files.length > 0 && submitButton}
      </div>
    );
  };

  return (
    <Modal
      onClose={() => {
        setLabel(t('PhotoType0'));
        onClose();
      }}
      open={open}
    >
      <Card className={clsx(classes.root, className)}>
        <form>
          <CardContent color="secondary">
            {loading ? (
              <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : (
              <Dropzone
                LayoutComponent={Layout}
                onChangeStatus={handleChangeStatus}
                onSubmit={handleSubmit}
                styles={{
                  dropzone: {
                    minHeight: 50,
                    maxHeight: 150,
                    overflowY: 'hidden',
                    overflowX: 'hidden'
                  },
                  preview: { padding: 20 },
                  inputLabelWithFiles: {
                    margin: 10,
                    alignItems: 'center',
                    alignSelf: 'center'
                  },
                  submitButtonContainer: {
                    display: 'flex',
                    justifyContent: 'center'
                  }
                }}
                inputContent={label}
                submitButtonContent={t('lblUpload')}
                accept="*"
                maxFiles={10}
                minSize={0}
                maxSize={8072000}
                inputWithFilesContent={t('lblEkle')}
              />
            )
            /*
<Dropzone
      LayoutComponent={Layout}
      onSubmit={handleSubmit}
      inputContent="Drop Files (Custom Layout)"
    />
                */
            }
            <br />
            <AlertYasal severity="warning">{t('upTo5File')}</AlertYasal>
          </CardContent>
          <Divider />
          <CardActions className={classes.actions}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                onClose();
              }}
            >
              {t('lblClose')}
            </Button>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}

FilePopup.defaultProps = {
  open: false,
  onClose: () => {}
};

export default FilePopup;
